import { helper as buildHelper } from '@ember/component/helper';
import {
  PROJECT_DETAILS__APPLICATION_EDITABLE_STATES_SELLER
} from '../../constants/routes/project-details';
import Moment from 'moment';

/**
 * Whether the provided application is editable by the indicated user type at this time. Currently
 * this is only used to determine editability of services. Location and cost/story codes have
 * different rules.
 *
 * @param {Application} application The application model.
 * @param {Boolean} isBuyer Whether the current user is the buyer.
 */
export function isApplicationEditable(application, isBuyer) {
  // Sellers can only edit the application during certain statuses.
  if (!isBuyer) {
    return PROJECT_DETAILS__APPLICATION_EDITABLE_STATES_SELLER.includes(application.get('status'));
  }

  // If there is no date, the application has not been completed yet, so buyers can edit freely.
  if (application.get('canEditUntil') === null) {
    return true;
  }

  // Once the application has been completed, buyers have a short period of time to edit.
  const currentTime = Moment().toDate().getTime();
  const cutoffTime = application.get('canEditUntil').getTime();
  return currentTime < cutoffTime;
}

export default buildHelper(isApplicationEditable);
